// Applies the LGU accent color from settings, deriving text-safe variants so contrast stays AA.

function hexToRgb(hex: string): [number, number, number] {
  const h = hex.replace('#', '');
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16)) as [number, number, number];
}
const toHex = (rgb: number[]) => '#' + rgb.map((v) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join('');
function luminance([r, g, b]: number[]): number {
  const c = [r, g, b].map((v) => {
    const s = v / 255;
    return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
}
export function contrast(a: string, b: string): number {
  const la = luminance(hexToRgb(a));
  const lb = luminance(hexToRgb(b));
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}
const mix = (a: number[], b: number[], t: number) => a.map((v, i) => v + (b[i] - v) * t);

export function applyAccent(accent: string | null | undefined): void {
  const root = document.documentElement.style;
  if (!accent || !/^#[0-9a-f]{6}$/i.test(accent)) {
    root.removeProperty('--accent');
    root.removeProperty('--accent-ink');
    root.removeProperty('--accent-tint');
    return;
  }
  const rgb = hexToRgb(accent);
  const tint = toHex(mix(rgb, [255, 255, 255], 0.84));
  let ink = accent;
  for (let t = 0; t <= 1 && contrast(ink, tint) < 4.6; t += 0.05) ink = toHex(mix(rgb, [0, 0, 0], t));
  root.setProperty('--accent', accent);
  root.setProperty('--accent-ink', ink);
  root.setProperty('--accent-tint', tint);
}
